import { render, staticRenderFns } from "./Thck.vue?vue&type=template&id=6ac752ad&scoped=true&"
import script from "./Thck.vue?vue&type=script&lang=js&"
export * from "./Thck.vue?vue&type=script&lang=js&"
import style0 from "./Thck.vue?vue&type=style&index=0&id=6ac752ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac752ad",
  null
  
)

export default component.exports